<template>
    <div v-loading="loading">
        <el-table :data="compare" key="add" border style="width:97%">
            <el-table-column label="修改项" prop="name"></el-table-column>
            <el-table-column label="修改前" prop="before" ></el-table-column>
            <el-table-column label="修改后" prop="after" class-name="red-text"></el-table-column>
        </el-table>
    </div>
</template>
<style>
.red-text {
  color: red;
}
</style>
<script>
    import Time from '~/common/time';
    export default {
        name: "division",
        props:{
            edit_content:{
                required:true
            }
        },
        data(){
            return {
                loading: false,
                apps:[],
                compare:[],
                product_type: {
                    '1': '试用',
                    '2': '新增',
                    '3': '续费',
                },
            }
        },
        mounted(){
            this.compareApp();
        },
        methods:{
            compareApp(){
                const before_content = this.edit_content.before_content;
                const after_content = this.edit_content.content;
                if(before_content.open_state != after_content.type){
                    this.addCompare('订单类型', this.product_type[before_content.open_state], this.product_type[after_content.type]);
                }
                // if(before_content.is_enable != after_content.is_enable){
                //     this.addCompare('产品开关', before_content.is_enable ? '开启' : '关闭', after_content.is_enable ? '开启' : '关闭');
                // }
                let before_start_at = before_content.start_at > 0 ? Time.asDateDay(before_content.start_at) : '';
                let before_end_at = before_content.end_at > 0 ? Time.asDateDay(before_content.end_at - 86400 * 1000) : '';
                let after_start_at = after_content.start_at > 0 ? Time.asDateDay(after_content.start_at) : '';
                let after_end_at = after_content.end_at > 0 ? Time.asDateDay(after_content.end_at) : '';
                if(before_start_at != after_start_at){
                    this.addCompare('开始时间', before_start_at, after_start_at);
                }
                if(before_end_at != after_end_at){
                    this.addCompare('结束时间', before_end_at, after_end_at);
                }
                if(before_content.memo != after_content.memo){
                    this.addCompare('备注', before_content.memo, after_content.memo);
                }
            },

            addCompare(name, before, after){
                this.compare.push({
                    name: name,
                    before: before,
                    after: after
                });
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/division.vue